import { Staff, State } from './types';

export default {
  getStaff(state: State): Array<Staff> {
    const staff = Object.values(state.staff);
    return staff;
  },
  getStaffById: (state: State) => (staffId: number) => state.staff.filter(staff => staff.id === staffId)[0] || {},
  getStaffRoles: (state: State) => (staffId: number) => {
    return state.staff.find(staff => staff.id === staffId)?.roles.map(role => role?.role?.name) || [];
  },
  getStaffForBroadcast: (state: State) => (broadcastId: string) => {
    return state.staff.filter(staff =>
      staff.roles
        .map(role => role.broadcasts)
        .flat()
        .includes(broadcastId)
    );
  },
  getRoleIdByName: (state: State, getters, rootState, rootGetters) => roleName => {
    const isCustomRolesEnabled = rootGetters['org/getCurrentOrg']?.isCustomRolesEnabled;
    if (isCustomRolesEnabled) {
      const roles = rootState.studioPermissions.rolesByRealm?.['event_app'] ?? [];
      return roles.find(role => role.name === roleName)?.id;
    }

    return state.availableRoles.find(role => role.name === roleName)?.id;
  },
  getSystemStaffRoles: (state: State) => {
    return state.systemStaffRoles;
  }
};
